<app-layout-main [pageMetadata]="{ title: appName() }" [layoutSize]="'small'" [design]="'focused'">
	<lib-focused-card [title]="'Reset password'">
		@if (malformedRequest()) {
		<div>
			<lib-message [type]="'warning'">The request for resetting password is malformed.</lib-message>
		</div>
		} @else { @if (!formSubmitted()) {

		<ui-text-form-field
			[title]="'New Password'"
			[textType]="'password'"
			[isRequired]="true"
			[valueAsSignal]="form.newPassword"
			[maxLength]="30"
		></ui-text-form-field>

		<ui-form-save-button
			[title]="'Set new password'"
			[saveHandler]="saveHandler()"
			[enableEnterSaveShortcut]="true"
			[logHandler]="formLogHandler()"
		></ui-form-save-button>
		} @else {
		<lib-message [type]="'success'"
			>Your password has been changed successfully. You may now login using the new password.</lib-message
		>

		<div class="push-top">
			<lib-button [routerLink]="loginRouterLink">Login</lib-button>
		</div>
		} }
	</lib-focused-card>
</app-layout-main>
